export function displayElem(id, display) {
  const elem = document.querySelector(id);
  elem.style.display = display;
}